module.exports = __webpack_public_path__ + "img/innate.0dc1262b.png";